import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Heart, MessageCircle, Share2 } from "lucide-react";
import Heading from "../../component/Heading/Heading";

const ClientTestimonial = () => {
  const [videosData, setVideosData] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const visibleVideos = 4;

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          "https://twinklemediahub.com/admin/sidenavabar/getclienttestimonial.php"
        );

        const text = await response.text();

        // ✅ VERY IMPORTANT FIX
        if (text.startsWith("<")) {
          throw new Error("API returned HTML instead of JSON");
        }

        const data = JSON.parse(text);

        const uniqueVideos = data.filter(
          (video, index, self) =>
            index === self.findIndex((v) => v.video_url === video.video_url)
        );

        setVideosData(uniqueVideos);
      } catch (err) {
        console.error("ERROR:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % videosData.length);
  };

  const handlePrev = () => {
    setStartIndex(
      (prev) => (prev - 1 + videosData.length) % videosData.length
    );
  };

  const getVisibleVideos = () => {
    const items = videosData.slice(startIndex, startIndex + visibleVideos);

    if (items.length < visibleVideos) {
      items.push(
        ...videosData.slice(0, visibleVideos - items.length)
      );
    }

    return items;
  };

  if (loading) return <p style={{ color: "#fff" }}>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (videosData.length === 0) return <p>No testimonials available</p>;

  const displayedVideos = getVisibleVideos();

  return (
    <div className="testimonial-container">
      <Heading headingLabel="Client Testimonials" />

      <div className="testimonial-slider">
        <button className="prev-btn" onClick={handlePrev}>
          <ChevronLeft />
        </button>

        <button className="next-btn" onClick={handleNext}>
          <ChevronRight />
        </button>

        <div className="video-slider">
          {displayedVideos.map((video, index) => (
            <div key={index} className="video-card">
              <video
                src={video.video_url}
                controls
                muted
                loop
                playsInline
              />

              <div className="overlay">
                <div className="info">
                  <p>{video.title || "Client Testimonial"}</p>
                </div>

                <div className="controls">
                  <Heart />
                  <MessageCircle />
                  <Share2 />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .testimonial-container {
          background: #000;
          padding: 40px;
          text-align: center;
        }

        .testimonial-slider {
          position: relative;
          overflow: hidden;
          margin-top: 20px;
        }

        .video-slider {
          display: flex;
          gap: 10px;
        }

        .video-card {
          flex: 0 0 calc(25% - 10px);
          position: relative;
          border-radius: 10px;
          overflow: hidden;
        }

        .video-card video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .overlay {
          position: absolute;
          bottom: 0;
          width: 100%;
          padding: 10px;
          background: linear-gradient(transparent, rgba(0,0,0,0.8));
          color: #fff;
          display: flex;
          justify-content: space-between;
        }

        .controls {
          display: flex;
          gap: 10px;
        }

        .prev-btn, .next-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.2);
          border: none;
          color: #fff;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 10;
        }

        .prev-btn { left: 10px; }
        .next-btn { right: 10px; }

        @media (max-width: 768px) {
          .video-card {
            flex: 0 0 calc(50% - 10px);
          }
        }

        @media (max-width: 480px) {
          .video-card {
            flex: 0 0 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default ClientTestimonial;